import { render, staticRenderFns } from "./PayPreferenceAccordion.vue?vue&type=template&id=80193fc6&scoped=true"
import script from "./PayPreferenceAccordion.vue?vue&type=script&lang=js"
export * from "./PayPreferenceAccordion.vue?vue&type=script&lang=js"
import style0 from "./PayPreferenceAccordion.vue?vue&type=style&index=0&id=80193fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80193fc6",
  null
  
)

export default component.exports